import TextField from "@material-ui/core/TextField";
import React, { useState } from "react";
import { Button, createStyles, makeStyles } from "@material-ui/core";
import { Chapter } from "../../../models/slides";
import { useInitText } from "../../../components/function/useInitText";
import { isEmpty } from "../../../utils/ObjectUtils";
import { useInitFlag } from "../../../components/function/useInitFlag";
import stylesPc from "../../viewer/UploadSlideStock.module.css";
import stylesSp from "../../viewer/UploadSlideStock_SP.module.css";
import { IsDevice } from "../../../components/function/useDeviceFlag";
import List from "@material-ui/icons/List";
import FList from "./FList";

interface IndexDetailInfoPrps {
    setIsSaved: (isSaved: boolean) => void;
    pageNumber: number;
    chapterLists: Chapter[];
    setChapterList: (chapterLists: Chapter[]) => void;
    isEditModal?: boolean;
}

function IndexDetailInfo({
    setIsSaved,
    pageNumber,
    chapterLists,
    setChapterList,
    isEditModal,
}: IndexDetailInfoPrps) {
    // レスポンシブ対応：ブラウザサイズによるCSSファイルの切り替え
    const styles = IsDevice("desktop") ? stylesPc : stylesSp;

    const useStyles = makeStyles(() =>
        createStyles({
            input: {
                width: "100%",
                "& .MuiOutlinedInput-root": {
                    color: isEditModal ? "white" : "black",
                    "&.Mui-focused fieldset": {
                        borderColor: isEditModal ? "var(--studio-btn-bg)" : "var(--main)",
                    },
                },
            },
            insertButton: {
                color: isEditModal ? "white" : "black",
                backgroundColor: isEditModal ? "var(--studio-btn-bg)" : "var(--main)",
                "&:hover": {
                    backgroundColor: isEditModal ? "var(--studio-btn-bg)" : "var(--main)",
                },
            },
        })
    );

    const classes = useStyles();

    // Index description情報
    const [indexdescription, setIndexDescription] = useInitText();
    // Index情報追加・Index編集ボタンボタン表示判断
    const [isIndexEdit, setIsIndexEdit] = useInitFlag();
    // Index情報追加ボタン活性・非活性用
    const [isIndexDisable, setIndexDisable] = useInitFlag(true);

    // Index情報入力値の設定
    const ChangeIndexDescription = (event: any) => {
        let currentChapter: Chapter | undefined;
        setIndexDescription(event.target.value);
        // 一つのページには一つのチャプターだけつけるの確認
        currentChapter = chapterLists.find((chapter: Chapter) => chapter.title === pageNumber);
        // 現在のページにチャプターがある場合は、チャプター情報追加ボタンの非活性
        if (currentChapter && !isIndexEdit) {
            setIndexDisable(true);
        } else if (isEmpty(event.target.value)) {
            setIndexDisable(true);
        } else {
            setIndexDisable(false);
        }
        setIsSaved(false);
    };

    // Index情報追加ボタンを押す時
    const addIndexInfoBtnClick = () => {
        // 説明で新規Chapterを作成
        const chap: Chapter = {
            id: 0, // 作成時、default値
            title: pageNumber,
            description: indexdescription,
        };
        // Indexリストに追加
        chapterLists.push(chap);
        // Index順番を並び替え
        sortChapter();
        // Index情報をクリアして追加ボタンを非活性にする
        setIndexDescription("");
        setIndexDisable(true);
    };

    // Index順番を並び替え
    const sortChapter = () => {
        // Index Title順番設定
        const sortedChapList = chapterLists.sort((chapter1, chapter2) => {
            return chapter1.title - chapter2.title;
        });
        // Index Id順番設定
        for (let i = 0; i < chapterLists.length; i++) {
            chapterLists[i].id = i;
        }
        setChapterList(sortedChapList);
    };

    // Index description情報編集、現在Index ID変数定義
    const [currentIndex, setCurrentIndex] = useState<null | Chapter>(null);
    // 編集するIndex情報の入力
    const editChapter = (id: string) => {
        let chapID = id.replace("chap.", "");
        setIndexDescription(chapterLists[parseInt(chapID)].description);
        setCurrentIndex(chapterLists[parseInt(chapID)]);
        setIndexDisable(false);
        setIsIndexEdit(true);
    };

    // Index情報編集ボタンを押す時
    const editIndexInfoBtnClick = () => {
        const editChapter: Chapter[] = [];
        chapterLists.forEach((chapter: Chapter) => {
            if (chapter.id === currentIndex?.id) {
                chapter.description = indexdescription;
            }
            editChapter.push(chapter);
        });
        // Indexリストに追加
        setChapterList(editChapter);
        // Index情報をクリアして追加ボタンを非活性にする
        setIndexDescription("");
        setIndexDisable(true);
        setIsIndexEdit(false);
    };

    // Index一覧の削除アイコンを押下処理
    const deleteChapter = (id: string) => {
        let chapID = id.replace("chap.", "");
        const newList: Chapter[] = chapterLists.filter(
            (chapter: Chapter) => chapter.id !== parseInt(chapID)
        );

        // Chapter一覧表示設定
        setChapterList(newList);
        // Index情報をクリアして追加ボタンを非活性にする
        setIndexDescription("");
        setIndexDisable(true);
        setIsIndexEdit(false);
    };

    // onMouseEnterイベント
    const onMouseEnter = (id: string) => {
        const currentonMouseEnterId = document.getElementById(id);
        if (currentonMouseEnterId) {
            currentonMouseEnterId.style.backgroundColor = "#FFFFFF";
            currentonMouseEnterId.style.border = "1px solid rgba(0,0,0,0.26)";
        }
    };

    // onMouseLeaveイベント
    const onMouseLeave = (id: string) => {
        const currentonMouseLeaveId = document.getElementById(id);
        if (currentonMouseLeaveId) {
            currentonMouseLeaveId.style.backgroundColor = "#F5F5F5";
            currentonMouseLeaveId.style.border = "1px solid rgba(245,245,245,0.26)";
        }
    };

    return (
        <>
            <div
                className={styles.chapterlistDiv}
                style={{ color: isEditModal ? "#9c9c9c" : "black" }}
            >
                <List className={styles.iconStyle}></List>INDEX
            </div>
            <div className={styles.formDetail}>
                <TextField
                    color="secondary"
                    id="indexInfo"
                    className={classes.input}
                    multiline
                    rows={3}
                    autoComplete="off"
                    variant="outlined"
                    value={indexdescription}
                    onChange={ChangeIndexDescription}
                    placeholder="INDEX説明を入力してください"
                />
            </div>
            <div className={styles.addChapDiv}>
                <Button
                    disabled={isIndexDisable}
                    size="small"
                    variant="contained"
                    color="secondary"
                    className={classes.insertButton}
                    onClick={isIndexEdit ? editIndexInfoBtnClick : addIndexInfoBtnClick}
                >
                    {isIndexEdit ? "Index情報編集" : "Index情報追加"}
                </Button>
            </div>
            {/* Index一覧情報表示 */}
            <div className={styles.chapterInfoListDiv}>
                {chapterLists != null &&
                    chapterLists.map((chapter: Chapter) => (
                        <div className={styles.chapterContentArea} key={chapter.id}>
                            {/* Index一覧で内容・削除アイコン表示 */}
                            <FList
                                id={`chap.${String(chapter.id)}`}
                                slideTitle={`P.${chapter.title}`}
                                description={chapter.description}
                                style={{
                                    border: "1px solid rgba(245,245,245,0.26)",
                                    width: "100%",
                                    backgroundColor: "#F5F5F5",
                                    borderRadius: "5px",
                                    marginBottom: "5px",
                                }}
                                deleteClick={deleteChapter}
                                editClick={editChapter}
                                onMouseEnter={() => onMouseEnter(`chap.${String(chapter.id)}`)}
                                onMouseLeave={() => onMouseLeave(`chap.${String(chapter.id)}`)}
                            />
                        </div>
                    ))}
            </div>
        </>
    );
}
export default IndexDetailInfo;
